// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__IfvuA","bold":"PrivacyPolicy_bold__2ZnED","italic":"PrivacyPolicy_italic__oFaHc","bulletList":"PrivacyPolicy_bulletList__ri1vV"};